import { render, staticRenderFns } from "./ReleaseButtons.vue?vue&type=template&id=65011072"
import script from "./ReleaseButtons.vue?vue&type=script&lang=ts"
export * from "./ReleaseButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports